import React from 'react'
import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/toolbox-helper'

import AndroidHandler from 'utils/androidHandler'
import { SelectionStepsV2 } from 'app/BCKSPage/components/SelectionSteps/SelectionStepsV2'
import Header from 'app/BCKSPage/components/Header'
import BCKSProfile from 'app/BCKSPage/components/BCKSProfile'
import { useBCKSDesktopView } from 'app/BCKSPage/hooks/useBCKSDesktopView'
import { BCKSDesktopPageShell } from 'app/BCKSPage/components/BCKSDesktopPageShell'

export const BCKSInvitationFinal = () => {
  const router = useRouter()
  const androidHandler = AndroidHandler()
  const { isDesktop } = useBCKSDesktopView()

  const handleBackToHome = () => {
    if (androidHandler.enabled) {
      historyUtils.backToApp(() => router.replace('/home'))
    } else {
      router.replace('/home')
    }
  }

  if (isDesktop) {
    return (
      <BCKSDesktopPageShell title="Proses Seleksi" pageLabel="Proses Seleksi">
        <div className="flex gap-6 items-start">
          {/* Left column — User info */}
          <div className="max-w-sm flex-1 shrink-0 sticky top-24 self-start space-y-4">
            <BCKSProfile className="rounded-lg border border-border-subdued" />
          </div>

          {/* Right column — selection steps */}
          <div className="flex-1 min-w-0 space-y-4">
            <div className="bg-white rounded-lg border border-border-subdued overflow-hidden">
              <SelectionStepsV2 />
            </div>
          </div>
        </div>
      </BCKSDesktopPageShell>
    )
  }

  return (
    <div className="min-h-screen max-w-xl mx-auto bg-surface-subdued">
      <Header
        withRightActionButton={false}
        title="Proses Seleksi"
        onBackClick={handleBackToHome}
      />

      <BCKSProfile className="border-b" />

      <div className="h-full">
        <SelectionStepsV2 />
      </div>
    </div>
  )
}
